import { routeDescription, routeTitle } from '@core/navigation/routes';
import { initProduct } from '@core/product/init.client';
import type { PageHead } from '@core/seo';
import type { LayoutLoad } from './$types';

export const load: LayoutLoad = async ({ data, url }) => {
  // Fire-and-forget: PostHog init must not block page rendering.
  // All analytics functions (capture, identify, reset) no-op gracefully
  // via optional chaining when the SDK hasn't finished initializing.
  initProduct(data.featureFlags);

  // Default head — child loads override `head` to set entity-specific
  // titles, descriptions, and social cards. Static pages get their title
  // and description from the route table; dynamic routes override.
  const head: PageHead = {
    title: routeTitle(url),
    description: routeDescription(url),
  };

  return { featureFlags: data.featureFlags, head };
};
